import { render, staticRenderFns } from "./numberseprator_test.vue?vue&type=template&id=74219ff4"
import script from "./numberseprator_test.vue?vue&type=script&lang=js"
export * from "./numberseprator_test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports